/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { WizardLauncherService } from '../../wizard.launcher.service';
import {
  AgentDownloadDialogService,
  DialogService,
  NotificationService,
  UserService,
  ValuesExchangeProvider,
  TimeoutWrapperService
} from '@nrwl/common-lib';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ComponentFactoryResolver,
  EventEmitter,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import { extend, get, indexOf, merge } from 'lodash';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { IWizardEntry } from '../../wizard.entry';
import { WizardComponent } from '../../wizard.component';
import { DatasourceCreateResultsComponent } from './datasource.create.results.page/datasource.create.results.component';
import { DatasourceDefinitionComponent } from './datasource.definition.page/datasource.definition.component';
import { DatasourceSiteSelectionComponent } from './datasource.site.selection.page/datasource.site.selection.component';
import {
  DataSource,
  DatasourceWizardService
} from '../../services/datasource/datasource.wizard.service';
import { DatasourceReviewComponent } from './datasource.review.page/datasource.review.component';
import { DatasourceAgentDescriptionComponent } from './datasource.agent.desc.page/datasource.agent.desc.component';
import { DatasourceAgentNetworkComponent } from './datasource.agent.network.page/datasource.agent.network.component';
import { DatasourceAgentProxyComponent } from './datasource.agent.proxy.page/datasource.agent.proxy.component';
import { DatasourceGigaTestReviewComponent } from './datasource.gigatest.review.page/datasource.gigatest.review.component';
import { DatasourceAgentUpgradeComponent } from './datasource.agent.upgrade.page/datasource.agent.upgrade';
import { DatasourceAgentUpgradeResultComponent } from './datasource.agent.upgrade.result.page/datasource.agent.upgrade.result.component';

@Component({
  selector: 'datasource-wizard',
  providers: [DatasourceWizardService],
  templateUrl: '../../wizard.template.html',
  styleUrls: ['../../wizard.component.style.scss', '../../wizard.button.style.scss']
})
export class DatasourceWizardComponent
  extends WizardComponent
  implements OnInit, AfterViewInit, OnDestroy, IWizardEntry
{
  //eslint-disable-next-line
  wizardConfig: any;
  wizardId: string;
  //eslint-disable-next-line
  dataId: any;
  //eslint-disable-next-line
  onClose = new EventEmitter<any>();
  //eslint-disable-next-line
  widgetConfig: any;
  state: Router;
  wizardService: DatasourceWizardService;
  userService: UserService;
  //eslint-disable-next-line
  openWizard: any;
  subscription: Subscription;
  changeDetectorRef: ChangeDetectorRef;
  closeWizardObj: Subscription;
  activatedRouteSubscription: Subscription;
  updateDataSourceIds = [
    'update_datasource',
    'update_gigatest_datasource',
    'update_gigaflow_datasource'
  ];

  // eslint-disable-next-line @typescript-eslint/member-ordering
  @ViewChild('contentPlaceholder', { read: ViewContainerRef, static: true })
  contentRef: ViewContainerRef;
  // eslint-disable-next-line @typescript-eslint/member-ordering
  @ViewChild('subContentPlaceholder', { read: ViewContainerRef, static: true })
  subContentRef: ViewContainerRef;

  constructor(
    state: Router,
    wizardService: DatasourceWizardService,
    userService: UserService,
    changeDetectorRef: ChangeDetectorRef,
    private readonly activatedRoute: ActivatedRoute,
    private readonly launcher: WizardLauncherService,
    private readonly factoryResolver: ComponentFactoryResolver,
    private readonly notificationService: NotificationService,
    private readonly agentDownloadDialogService: AgentDownloadDialogService,
    private readonly dialogService: DialogService,
    private readonly valuesExchangeProvider: ValuesExchangeProvider,
    private readonly timeout: TimeoutWrapperService
  ) {
    super();
    this.state = state;
    this.wizardService = wizardService;
    this.userService = userService;
    this.changeDetectorRef = changeDetectorRef;
  }

  ngOnInit() {
    this.activatedRouteSubscription = this.activatedRoute.queryParams.subscribe(data => {
      let defaultParams = merge({}, this.dataId, JSON.parse(get(data, 'defaultParams', '{}')));
      this.wizardService.editMode = indexOf(this.updateDataSourceIds, this.wizardId) > -1;
      if (this.wizardService.editMode) {
        defaultParams = this.wizardService.populateDataForEditMode(defaultParams);
      }
      this.wizardService.openWizard(
        this.wizardId,
        this.wizardConfig,
        defaultParams,
        this.onSuccessCallback.bind(this),
        this.onFailureCallback.bind(this)
      );
    });
    this.closeWizardObj = this.wizardService.closeWizard.subscribe(status => {
      if (status) {
        this.toggleClose();
      }
    });
    this.wizardService.registerToggleListener(this.notifyOnToggleSubContent.bind(this));
  }

  ngAfterViewInit() {
    this.createContentComponent();
    this.changeDetectorRef.detectChanges();
  }

  ngOnDestroy() {
    if (this.closeWizardObj) {
      this.closeWizardObj.unsubscribe();
    }
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.activatedRouteSubscription) {
      this.activatedRouteSubscription.unsubscribe();
    }
  }

  get(object, path: string) {
    return get(object, path);
  }

  onSuccessCallback(object) {
    if (object.platform === 'OLHW') {
      this.notificationService.onHWAgentBuildSuccess(extend({}, object));
    } else {
      if (!this.wizardService.wizardActive) {
        this.notificationService.onAgentBuildSuccess(extend({}, object), id =>
          this.agentDownloadDialogService.openDialog(id)
        );
      }
    }
  }

  onFailureCallback() {
    const dataSourceType = this.wizardService.output?.datasourceType?.id;
    if (dataSourceType === DataSource.GIGA_TEST) {
      this.notificationService.onUnknownCreateAgentErrorOccurred();
    }
  }

  //-------------- Control && Validation -----------------------
  toggleNext() {
    this.wizardService.nextStep();
    this.createContentComponent();
  }

  toggleBack() {
    this.wizardService.previousStep();
    this.createContentComponent();
  }

  toggleFinish() {
    if (this.wizardService.id === 'wizardService.upgrade_agent') {
      this.upgradeAgent();
      return;
    }
    const output = this.wizardService.output;
    if (
      output.datasourceType &&
      output.datasourceType.id === DataSource.GIGA_TEST &&
      this.wizardService.editMode &&
      output.previousSite !== output.site
    ) {
      this.askForConfirmation('wizardService.update_gigatest_site', this.onFinishAgent);
    } else {
      this.onFinishAgent(this);
    }
  }

  upgradeAgent() {
    const result = (this.wizardService as DatasourceWizardService).onAgentUpgrade();
    result.subscribe(response => {
      this.createContentComponent();
      this.timeout.add(() => {
        this.valuesExchangeProvider.notifyListeners('onDatasourceUpdated', {
          time: new Date().getTime()
        });
      }, 5000);
    });
  }

  askForConfirmation(id, onConfirm) {
    const params = {
      id: id,
      callBackService: this,
      callBackFuntion: onConfirm
    };
    if (this.dialogService) {
      this.dialogService.showDialog('confirm', 'body', params);
    }
  }

  onFinishAgent(service) {
    const result = (service.wizardService as DatasourceWizardService).onFinish();
    service.valuesExchangeProvider.notifyListeners('onDatasourceUpdated', { outcome: null });
    result.subscribe(outcome => {
      service.valuesExchangeProvider.notifyListeners('onDatasourceUpdated', { outcome });
      service.createContentComponent();
    });
  }

  retryOperation() {
    (this.wizardService as DatasourceWizardService).retrySaveRequest();
  }

  editSite() {
    this.wizardService.goToStep('datasource_location');
    this.createContentComponent();
  }

  editHost() {
    this.wizardService.goToStep('datasource_definition');
    this.createContentComponent();
  }

  editAlias() {
    this.wizardService.goToStep('datasource_agent_desc');
    this.createContentComponent();
  }

  editNetwork() {
    this.wizardService.goToStep('datasource_network');
    this.createContentComponent();
  }

  editProxy() {
    this.wizardService.goToStep('datasource_proxy_settings');
    this.createContentComponent();
  }

  editDatasourceType() {
    this.wizardService.goToStep('datasource_selection');
    this.createContentComponent();
  }

  toggleClose() {
    this.wizardService.toggleClose(() => this.onClose.emit(true));
  }

  toggleReOpen() {
    this.wizardService.reOpen();
  }

  notifyOnToggleSubContent(onOff) {
    if (onOff) {
      this.createSubContentComponent();
    } else {
      this.subContentRef.clear();
    }
  }

  getWizardService() {
    return this.wizardService;
  }

  getFactoryResolver() {
    return this.factoryResolver;
  }

  getContentViewRef() {
    return this.contentRef;
  }

  getSubContentViewRef() {
    return this.subContentRef;
  }

  isValidStep(step: string): boolean {
    return this.wizardConfig.steps.find(i => i.id === step);
  }

  resolveComponentType(pageId) {
    switch (pageId) {
      case 'datasource.defintion.html':
        return DatasourceDefinitionComponent;
      case 'datasource.site.selection.html':
        return DatasourceSiteSelectionComponent;
      case 'datasource.review.html':
        return DatasourceReviewComponent;
      case 'datasource.create.results.html':
        return DatasourceCreateResultsComponent;
      case 'datasource.agent.desc.html':
        return DatasourceAgentDescriptionComponent;
      case 'datasource.agent.network.html':
        return DatasourceAgentNetworkComponent;
      case 'datasource.agent.proxy.html':
        return DatasourceAgentProxyComponent;
      case 'datasource.gigatest.review.html':
        return DatasourceGigaTestReviewComponent;
      case 'datasource.upgrade.agent.html':
        return DatasourceAgentUpgradeComponent;
      case 'datasource.agent.upgrade.result.html':
        return DatasourceAgentUpgradeResultComponent;
      default: {
        console.error('Unrecognized template name:', pageId);
        return null;
      }
    }
  }
}
